export const DefaultLanguage = 'en-GB';

export const SupportedLanguages = [
  { language: 'bg', locale: 'bg-BG', crowdin: 'bg' },
  { language: 'cs', locale: 'cs-CS', crowdin: 'cs' },
  { language: 'da', locale: 'da-DK', crowdin: 'da' },
  { language: 'de', locale: 'de-DE', crowdin: 'de' },
  { language: 'en', locale: 'en-GB', crowdin: 'en-GB' },
  { language: 'es', locale: 'es-ES', crowdin: 'es-ES' },
  { language: 'fr', locale: 'fr-FR', crowdin: 'fr' },
  { language: 'he', locale: 'he-IL', crowdin: 'he' },
  { language: 'hu', locale: 'hu-HU', crowdin: 'hu' },
  { language: 'it', locale: 'it-IT', crowdin: 'it' },
  { language: 'nl', locale: 'nl-NL', crowdin: 'nl' },
  { language: 'no', locale: 'no-NO', crowdin: 'no' },
  { language: 'pl', locale: 'pl-PL', crowdin: 'pl' },
  { language: 'pt', locale: 'pt-PT', crowdin: 'pt-PT' },
  { language: 'ro', locale: 'ro-RO', crowdin: 'ro' },
  { language: 'ru', locale: 'ru-RU', crowdin: 'ru' },
  { language: 'sk', locale: 'sk-SK', crowdin: 'sk' },
  { language: 'sv', locale: 'sv-SE', crowdin: 'sv-SE' },
  { language: 'tr', locale: 'tr-TR', crowdin: 'tr' },
  { language: 'uk', locale: 'uk-UA', crowdin: 'uk' },
];

/**
 * @param code Language code in any format ('xx' or 'xx-xx')
 * @returns The first two letters of the given code
 * which represents the country
 */
export function getCountryCode(code: string): string {
  const countryCode = code.match(/[A-z]+-/g)
    ? code.match(/[A-z]+-/g)[0].slice(0, 2)
    : code;

  return countryCode;
}

/**
 * @param code Language code in any format ('xx' or 'xx-xx')
 * @returns the crowdin language code or `null` if it's not found
 */
export function getCrowdinCode(code: string): string {
  const language = SupportedLanguages.find(l => {
    const countryCode = getCountryCode(code);
    if (code === l.locale) return true;
    else if (countryCode === l.language) return true;
    else return false;
  });

  return language?.crowdin;
}
